import { api } from "constants/RotasAPI";
import { useGestaoCobrancaCadastroContext } from "context/gestaoCobranca/GestaoCobrancaCadastroContext";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { Page } from "types/dto/Page";
import { InadimplenciaDTO } from "types/dto/RegistroInadimplenciaDTO";
import { RequestInadimplencias } from "types/request/RequestInadimplencias";

export const useGetInadimplencias = (request: RequestInadimplencias) => {
  const { setInadimplencias } = useGestaoCobrancaCadastroContext();

  const onSuccess = (response: Page<InadimplenciaDTO>) => {
    setInadimplencias(response.content);
  };

  const onError = () => {
    toast.error("Erro ao buscar lista de inadimplencias");
  };

  return useFetch<Page<InadimplenciaDTO>>({
    key: ["inadimplencias", request.unidadeId, request.page, request.sort],
    url: api.contaReceber.getInadimplenciasCorrigidas,
    params: request,
    enabled: request.unidadeId !== undefined,
    onSuccess,
    onError,
  });
};
